export default "__VITE_ASSET__$FjiW9Ih__"